<div class="container-fluid">
    <div class="row fondoAmarillo">
        <div class="col-lg-2">
            <img src="assets/img/auri.png" height="60px">
        </div>
        <div class="col-lg-8">
            <br>
            <p class="center blanco">¡Bienvenido 
                <!-- <span class="bold">{{dataUsuario.first_name}}</span>! -->
            </p>
        </div>
        <div class="col-lg-2">
            <br>
            <p><a class="blanco bold" (click)="closeSesion()">Cerrar Sesión</a></p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <br>
            <h5 class="text-center">¡Por favor elige tu paquete!</h5>
            <br>
        </div>
        <div class="col-lg-3" *ngFor="let paquete of paquetes">
            <div *ngIf="paquete.imagen; else imagenAuri">
                <div class="img-magnifier-container">
                    <img src="{{environment}}{{paquete.imagen}}" width="100%">
                </div>
            </div>
            <ng-template #imagenAuri>
                <img src="assets/img/auri.png" width="100%"><br>
            </ng-template>
            <p class="center">{{paquete.nombre}}
                <br><strong>{{paquete.precio | currency}}</strong><br>
                <button (click)="getDetallePaquete(paquete.id)" class="btn btn-primary fondoAmarillo" style="border: 0px;">Ver Detalles</button>
            </p>
            <!-- <div *ngIf="solicitado==0"> -->
                <!-- <button class="fondoAmarillo border0 input90" (click)="agregarPaqueteCliente(paquete.id, clienteId)">Agregar Paquete</button><br><br> -->
            <!-- </div>  -->
        </div>
    </div>
</div>
                    

<div id="clickPaquete" (click)="openModal(mymodal2)"></div>
<ng-template #mymodal2 let-c="close" let-d="dismiss">

    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{nombrePaquete}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissAll()">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <div class="modal-body">
        <p>{{descripcion}}</p>
        <h5>Incluye:</h5>
        <img src="{{environment}}{{paqueteImagen}}" width="300px">
        <ul>
            <li *ngFor="let producto of detallePaquete">{{producto.nombre}}</li>
        </ul>
        <button class="btn btn-success" (click)="seleccionarPaqueteCliente()">Eligir</button>
    </div>

    <div class="modal-footer">
    </div>
</ng-template>